import { render, staticRenderFns } from "./version--detail.vue?vue&type=template&id=15a69f14&scoped=true&"
import script from "./version--detail.vue?vue&type=script&lang=js&"
export * from "./version--detail.vue?vue&type=script&lang=js&"
import style0 from "./version--detail.vue?vue&type=style&index=0&id=15a69f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a69f14",
  null
  
)

export default component.exports